import {newSpecPage} from '@stencil/core/testing';
import {JoyWrapper} from '../wrapper';
import {Input} from '../../JoyInput/input';

it('should have a wrapper with custom row gap class', async () => {
    const page = await newSpecPage({
        components: [JoyWrapper, Input],
        html: `
            <joy-wrapper row-gap="10">
                <joy-input icon="location" value="New York" name="my-location-input">My basic input with icon</joy-input>
                <joy-input required type="number" unit="%" value="300" name="my-location-input">My unit input</joy-input>
                <joy-input value="I am a value" autocomplete="off" name="my-stencil-input">My input label</joy-input>
            </joy-wrapper>
        `,
    });
    expect(page.root?.shadowRoot?.querySelector('.joy-wrapper')?.classList.contains('joy-wrapper--row-gap-10')).toBe(true);
});

it('should have a wrapper with custom column gap class', async () => {
    const page = await newSpecPage({
        components: [JoyWrapper, Input],
        html: `
            <joy-wrapper column-gap="10">
                <joy-input icon="location" value="New York" name="my-location-input">My basic input with icon</joy-input>
                <joy-input required type="number" unit="%" value="300" name="my-location-input">My unit input</joy-input>
                <joy-input value="I am a value" autocomplete="off" name="my-stencil-input">My input label</joy-input>
            </joy-wrapper>
        `,
    });
    expect(page.root?.shadowRoot?.querySelector('.joy-wrapper')?.classList.contains('joy-wrapper--column-gap-10')).toBe(true);
});

it('should have a wrapper with default row and column gaps', async () => {
    const page = await newSpecPage({
        components: [JoyWrapper, Input],
        html: `
            <joy-wrapper>
                <joy-input icon="location" value="New York" name="my-location-input">My basic input with icon</joy-input>
                <joy-input required type="number" unit="%" value="300" name="my-location-input">My unit input</joy-input>
                <joy-input value="I am a value" autocomplete="off" name="my-stencil-input">My input label</joy-input>
            </joy-wrapper>
        `,
    });
    expect(page.root?.shadowRoot?.querySelector('.joy-wrapper')?.classList.contains('joy-wrapper--column-gap-4')).toBe(true);
    expect(page.root?.shadowRoot?.querySelector('.joy-wrapper')?.classList.contains('joy-wrapper--row-gap-8')).toBe(true);
});
